import { Fragment } from 'react'

// As returning null here would make the return type this as a null, a Fragment is used in order to easier DI
// oxlint-disable-next-line react/jsx-no-useless-fragment
export const NullReturn = () => <Fragment />
